import { combineReducers } from "redux"

import {
  SWITCH_USER,
  UPDATE_CUSTOMER,
  DELETE_CUSTOMER,
  SET_OWNED_PRODUCTS,
  UPDATE_OWNED_PRODUCTS,
  DELETE_OWNED_PRODUCTS,
  SET_SUBSCRIPTIONS,
  UPDATE_SUBSCRIPTIONS,
  DELETE_SUBSCRIPTIONS,
  UPDATE_AWS_CREDENTIALS,
  DELETE_AWS_CREDENTIALS,
  UPDATE_GCP_CREDENTIALS,
  DELETE_GCP_CREDENTIALS,
  UPDATE_AZURE_CREDENTIALS,
  DELETE_AZURE_CREDENTIALS,
  DISMISS_POPUPS,
  RESET_POPUPS,
  TOGGLE_DARK_MODE,
  RESET_DARK_MODE,
} from "./actions"

function user(state={}, action) {
  switch(action.type) {
    case SWITCH_USER:
      return action.user
    default:
      return state
  }
}

function customer(state={}, action) {
  switch(action.type) {
    case UPDATE_CUSTOMER:
      return Object.assign(
        {},
        state,
        action.customer
      )
    case DELETE_CUSTOMER:
      return null
    default:
      return state
  }
}

function ownedProducts(state=[], action) {
  switch(action.type) {
    case SET_OWNED_PRODUCTS:
      return action.ownedProducts || []
    case UPDATE_OWNED_PRODUCTS:
      return Array.from(new Set(
        state.concat(action.ownedProducts)
      ))
    case DELETE_OWNED_PRODUCTS:
      return []
    default:
      return state
  }
}

function subscriptions(state=[], action) {
  switch(action.type) {
    case SET_SUBSCRIPTIONS:
      return action.subscriptions || []
    case UPDATE_SUBSCRIPTIONS:
      return Array.from(new Set(
        state.concat(action.subscriptions)
      ))
    case DELETE_SUBSCRIPTIONS:
      return []
    default:
      return state
  }
}

function awsCredentials(state={}, action) {
  switch(action.type) {
    case UPDATE_AWS_CREDENTIALS:
      return Object.assign(
        {},
        state,
        action.awsCredentials
      )
    case DELETE_AWS_CREDENTIALS:
      return {}
    default:
      return state
  }
}

function gcpCredentials(state={}, action) {
  switch(action.type) {
    case UPDATE_GCP_CREDENTIALS:
      return Object.assign(
        {},
        state,
        action.gcpCredentials
      )
    case DELETE_GCP_CREDENTIALS:
      return {}
    default:
      return state
  }
}

function azureCredentials(state={}, action) {
  switch(action.type) {
    case UPDATE_AZURE_CREDENTIALS:
      return Object.assign(
        {},
        state,
        action.azureCredentials
      )
    case DELETE_AZURE_CREDENTIALS:
      return {}
    default:
      return state
  }
}

function dismissedPopups(state=[], action) {
  switch(action.type) {
    case DISMISS_POPUPS:
      return Array.from(new Set(
        state.concat(action.dismissedPopups)
      ))
    case RESET_POPUPS:
      return []
    default:
      return state
  }
}

function darkMode(state={}, action) {
  switch(action.type) {
    case TOGGLE_DARK_MODE:
      return Object.assign(
        {},
        state,
        {darkMode: !state.darkMode}
      )
    case RESET_DARK_MODE:
      return null
    default:
      return state
  }
}

export const reducer = combineReducers({
  user,
  customer,
  ownedProducts,
  subscriptions,
  awsCredentials,
  gcpCredentials,
  azureCredentials,
  dismissedPopups,
  darkMode,
})

export default reducer
